/** @jsx jsx */
import { Container, Flex, Loader } from "@eworkit/iris";
import { FC, Suspense } from "react";
import { jsx } from "theme-ui";

interface AppSuspenseProps {}

export const AppSuspense: FC<AppSuspenseProps> = ({ children }) => {
  return (
    <Suspense
      fallback={
        <Container>
          <Flex alignItems="center" justifyContent="center" my="xl">
            <Loader size="xl" color="vg500" />
          </Flex>
        </Container>
      }>
      {children}
    </Suspense>
  );
};
